import type { Permission } from "./config";
import { PERMISSIONS } from "./config";

interface RoutePermissionMap {
  pattern: RegExp;
  permission: Permission;
}

// Route pattern'lerini ve PAGE permission'larını eşleştiren map.
// PAGE her modülün master anahtarıdır — yoksa ProtectedRoute direkt
// /unauthorized'a yönlendirir. Sayfa açıldıktan sonraki aksiyonlar
// (oluşturma/güncelleme/silme) ayrıca kendi VIEW/CREATE/UPDATE/DELETE
// yetkilerine bakar.
export const ROUTE_PERMISSION_MAP: RoutePermissionMap[] = [
  // Eğitim edit sayfası: EDUCATION_MANAGER/CENTRAL_MANAGER GLOBAL UPDATE ile,
  // atanan EDUCATION_SUPERVISOR ise per-education manager atamasıyla erişebilir.
  // Route guard'ı PAGE'e açıyoruz; backend `EducationAccessGuard` PATCH'i koruyor
  // ve `educationManagerIds` strict SUPERVISOR'dan reddediliyor (yetki yükseltme).
  { pattern: /^\/education-management\/[^/]+\/edit$/, permission: PERMISSIONS.EDUCATION_PAGE },
  // Manager (planlama) sayfası: EDUCATION_MANAGER/CENTRAL_MANAGER GLOBAL UPDATE
  // ile, atanan EDUCATION_SUPERVISOR ise per-education yönetici atamasıyla
  // erişebilir. Route guard'ı PAGE'e açıyoruz; spesifik aksiyonlar
  // (kişi ekleme/silme/onay) sayfa içinde `isEducationManager` flag'i ile,
  // backend tarafında ise `EducationAccessGuard` ile zaten korunuyor.
  { pattern: /^\/request-and-approval\/education\/[^/]+\/manager$/, permission: PERMISSIONS.EDUCATION_PAGE },
  // Officer (talepleri incele) — EDUCATION_SUPERVISOR/BRANCH_MANAGER için PAGE yeterli;
  // sayfa içindeki aksiyonlar (örn. kişi ekleme) kendi CREATE yetkisini kontrol ediyor
  { pattern: /^\/request-and-approval\/education\/[^/]+\/officer$/, permission: PERMISSIONS.REQUEST_AND_APPROVAL_PAGE },
  { pattern: /^\/roles-and-permissions$/, permission: PERMISSIONS.ROLES_AND_PERMISSIONS_PAGE },
  { pattern: /^\/announcements$/, permission: PERMISSIONS.ANNOUNCEMENTS_PAGE },
  { pattern: /^\/black-list$/, permission: PERMISSIONS.BLACK_LIST_PAGE },
  { pattern: /^\/categories$/, permission: PERMISSIONS.CATEGORIES_PAGE },
  { pattern: /^\/education-management/, permission: PERMISSIONS.EDUCATION_PAGE },
  { pattern: /^\/education-calendar/, permission: PERMISSIONS.EDUCATION_PAGE },
  { pattern: /^\/exam-management/, permission: PERMISSIONS.EXAMS_PAGE },
  { pattern: /^\/polls/, permission: PERMISSIONS.POLLS_PAGE },
  { pattern: /^\/items$/, permission: PERMISSIONS.ITEMS_PAGE },
  { pattern: /^\/admin-library/, permission: PERMISSIONS.LIBRARY_PAGE },
  { pattern: /^\/intern-management/, permission: PERMISSIONS.INTERN_PAGE },
  { pattern: /^\/staff-management/, permission: PERMISSIONS.STAFF_PAGE },
  { pattern: /^\/departments/, permission: PERMISSIONS.DEPARTMENTS_PAGE },
  { pattern: /^\/locations/, permission: PERMISSIONS.LOCATIONS_PAGE },
  { pattern: /^\/sms-broadcast$/, permission: PERMISSIONS.SMS_BROADCAST_PAGE },
  { pattern: /^\/mail-broadcast$/, permission: PERMISSIONS.EMAIL_BROADCAST_PAGE },
  { pattern: /^\/certificates/, permission: PERMISSIONS.CERTIFICATES_PAGE },
  { pattern: /^\/support-tickets/, permission: PERMISSIONS.SUPPORT_TICKETS_PAGE },
  { pattern: /^\/client-support-tickets/, permission: PERMISSIONS.SUPPORT_TICKETS_PAGE },
  { pattern: /^\/request-and-approval/, permission: PERMISSIONS.REQUEST_AND_APPROVAL_PAGE },
  { pattern: /^\/approval-flows/, permission: PERMISSIONS.APPROVAL_FLOWS_PAGE },
  { pattern: /^\/reports/, permission: PERMISSIONS.REPORTS_PAGE },
  { pattern: /^\/logs$/, permission: PERMISSIONS.LOGS_PAGE },
];

// Path için gerekli permission'ı bul
export const getRoutePermission = (path: string): Permission | null => {
  const route = ROUTE_PERMISSION_MAP.find((route) => route.pattern.test(path));
  return route?.permission || null;
};
